import styled from 'styled-components';
import {
  textLightGrey,
  lgGreen,
  black,
  lgGrey3,
  orange,
  white,
  darkWhite,
} from '../../constants/theme';

export const HintMenu = styled.div`
  display: flex;
  div {
    padding: 0;
    text-align: center;
  }

  .modal-header {
    margin: 40px 40px 35px 40px;
    width: 100%;
    border-bottom: none;
    align-items: center;
    justify-content: center;
  }

  &.footer {
    margin: 0;
    padding: 0;
  }
  h5 {
    color: ${textLightGrey};
    font-size: 16px;
  }
  button {
    padding: 0;
    margin: 0;
    color: #333333;
    font-size: 16px;
    &:disabled {
      color: ${textLightGrey};
    }
  }
  .active {
    & button {
      color: ${lgGreen};
    }
  }
  .ok-btn {
    font-weight: bold;
    font-size: 16px;
    color: white;
    background-color: ${lgGreen};
    height: 40px;
    width: 82px;
  }
  @media screen and (max-width: 1024px) {
    .selected {
      font-size: 12px;
      line-height: 22px;
    }

    button {
      font-size: 12px;
    }
    .modal-header {
      margin: 25px 40px 25px 40px;
      width: 100%;
      border-bottom: none;
      align-items: center;
      justify-content: center;
      h4 {
        font-size: 24px;
      }
    }

    .ok-btn {
      font-weight: bold;
      color: white;
      background-color: ${lgGreen};
      padding: 5px 20px;
      margin-top: 20px;
      width: 100%;
    }
  }
  @media screen and (max-width: 1024px) {
    .deskContent {
      display: none;
    }
    .phoneContent {
      display: flex !important;
    }
  }
  @media screen and (min-width: 1025px) {
    .deskContent {
      display: flex !important;
    }
    .phoneContent {
      display: none;
    }
  }
  @media (min-width: 992px) and (max-width: 1024px) {
    .col-lg-7 {
      flex: 0 0 100%;
      max-width: 100%;
    }
    .col-lg-1 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const Button = styled.button`
  outline: none;
  text-align: left;
  padding: 0;

  &.active {
    background-color: ${lgGreen} !important;
    outline: none;
    color: white !important;
    padding: 0 2px 0 2px;
    margin: 2px 0 2px 0;
  }
`;
export const ModalStyle = styled.div`
  .condition-row {
    // -moz-column-width: 13em;
    // // -webkit-column-width: 36em !important;
    // -moz-column-gap: 1em;
    -webkit-column-gap: 1em;
  }
  .sub-conditions {
    margin: 10px 0 35px 0;
    font-size: 13px;
    line-height: 22px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .condition-col {
    width: 46%;

    button:focus {
      outline: none !important;
      background: transparent;
      color: ${textLightGrey};
    }
  }
  .healthy-vol {
    color: ${black};
    font-size: 14px;
    width: 30%;
    h3 {
      font-weight: 600;
    }
    .col {
      padding: 0;
    }
    p {
      margin-bottom: 0 !important;
    }
  }
  .check-div {
    margin-top: 15px;
    margin-right: 10px;
    display: flex;
  }
  .check-box {
    margin-right: 10px;
  }
  .condition-flow {
    margin: 0 40px 0 40px;
    display: flex;
    flex-direction: column;
    height: 540px;
    flex-wrap: wrap;
  }
  @media screen and (max-width: 1024px) {
    height: 100vh;
    .deskContent {
      display: none;
    }
    .phoneContent {
      display: block;
    }
    .condition-col {
      width: 100%;
      max-width: 100%;
      padding: 15px 0;
      border-bottom: 1px solid ${lgGrey3};
    }
    .sub-conditions {
      margin: 20px 0 10px 0;
    }
    .healthy-vol {
      width: 100%;
      padding: 15px 0;
      font-size: 16px;
      border-bottom: 1px solid ${lgGrey3};
    }
    .condition-flow {
      height: auto;
      background-color: ${white};
      margin: 0;
      padding: 120px 40px 160px 40px;
    }
    .has-children {
      display: flex;
      justify-content: space-between;
      svg {
        color: ${orange};
        width: 30px;
      }
    }
    .footer {
      width: 100%;
      position: fixed;
      bottom: 0;
      border-top: 1px solid ${darkWhite};
      background-color: ${white};
    }
    .header-mobile {
      width: 100%;
      position: fixed;
      top: 0;
      background-color: ${white};
      border-bottom: 1px solid ${darkWhite};
    }
  }
  @media screen and (min-width: 1025px) {
    .deskContent {
      display: block;
    }
    .phoneContent {
      display: none !important;
    }
  }
`;
